import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PrivacyPolicyComponent } from "./privacy-policy.component";

@NgModule({
  declarations: [
    PrivacyPolicyComponent
  ],
  imports: [
    CommonModule
],
  exports: [
    PrivacyPolicyComponent
  ]
})
export class PrivacyPolicyModule { }